<section class="actions">
  <button type="button" mat-raised-button *ngIf="!isLoading" color="primary" [disabled]="disabling" (click)="onSubmit()">{{
    "global.validateAndCancel.validate" | translate }}</button>

  <button type="button" mat-raised-button color="primary" *ngIf="!isLoading" (click)="onCancel()">{{ "global.validateAndCancel.cancel"
    | translate}}</button>
</section>